import React, { createContext, useContext, useState } from 'react';

interface LogoEditorContextType {
  isEditing: boolean;
  setIsEditing: (isEditing: boolean) => void;
}

const LogoEditorContext = createContext<LogoEditorContextType | undefined>(undefined);

export const LogoEditorProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isEditing, setIsEditing] = useState(false);

  return (
    <LogoEditorContext.Provider value={{ isEditing, setIsEditing }}>
      {children}
    </LogoEditorContext.Provider>
  );
};

export const useLogoEditor = () => {
  const context = useContext(LogoEditorContext);
  if (context === undefined) {
    throw new Error('useLogoEditor must be used within a LogoEditorProvider');
  }
  return context;
};
